/**
 * 助理长期记忆。
 * 条目存在账号下的 chat.memory，不再使用浏览器种子数据。
 */
import { assistantApi, type MemoryRow } from '@/data/api/assistant'
import { emit } from './events'

export interface MemoryItem { id: string; text: string; at: number }

function mapRows(rows: MemoryRow[]): MemoryItem[] {
  return rows.map(row => ({ id: row.id, text: row.text, at: Date.parse(row.createdAt) || Date.now() }))
}

export async function loadMemory(): Promise<MemoryItem[]> {
  const items = mapRows(await assistantApi.memories())
  return items
}

export async function addMemory(text: string): Promise<MemoryItem[]> {
  await assistantApi.createMemory(text)
  const items = await loadMemory()
  emit('memory:changed', items)
  return items
}

export async function removeMemory(id: string): Promise<MemoryItem[]> {
  await assistantApi.removeMemory(id)
  const items = await loadMemory()
  emit('memory:changed', items)
  return items
}

export async function clearMemory(): Promise<MemoryItem[]> {
  await assistantApi.clearMemories()
  const items: MemoryItem[] = []
  emit('memory:changed', items)
  return items
}
